<div class="content solo">
    <section class="child">
        <h1>{{'setTemplate.selectTemplate'|translate}}</h1>
        <p class="form-description" ng-if="vm.templateDescription">{{vm.templateDescription}}</p>
        <div class="abstract">{{'setTemplate.abstract'|translate}}</div>
        <div ng-if="vm.showTemplateList" c-select-list toggle="0" items="vm.templates" selected-item="vm.selectedTemplate" validation="vm.setupValidation" auto-select-single-item="true"></div>
        <div ng-if="vm.showTemplateList===false" class="error-text">{{'setTemplate.noTemplateFound'|translate}}</div>
    </section>
</div>
